import Login from "../../layouts/Login";
import { LoginType } from "../../utils/Common";
function AdmissionLogin() {
  return <Login type={LoginType.ADMISSION} />;
}
export default AdmissionLogin;
